/*
  preorder-notice.js — bascule de la notice de précommande (Itsara, maison).
  Chargé globalement (layout/theme.liquid) pour rester actif y compris quand le
  pop-up quick-view est injecté en AJAX. Lit la carte des variantes preorder
  embarquée par buy-buttons.liquid en data-attribut, et affiche/masque chaque
  .preorder-notice selon la variante actuellement sélectionnée dans son formulaire.
  Le 1er affichage est déjà correct via le style inline rendu côté serveur ; ce
  script ne fait que maintenir la synchro au changement de taille.
*/
(function () {
  'use strict';

  function updateNotice(notice) {
    var formId = notice.getAttribute('data-form-id');
    var form = formId ? document.getElementById(formId) : null;
    if (!form) return;

    var input = form.querySelector('[data-product-select]');
    if (!input) return;

    var map;
    try {
      map = JSON.parse(notice.getAttribute('data-preorder-variants') || '{}');
    } catch (e) {
      return;
    }

    notice.style.display = map[input.value] === true ? 'block' : 'none';
  }

  function updateAll() {
    var notices = document.querySelectorAll('.preorder-notice[data-preorder-variants]');
    for (var i = 0; i < notices.length; i++) {
      updateNotice(notices[i]);
    }
  }

  if (document.readyState !== 'loading') {
    updateAll();
  }
  document.addEventListener('DOMContentLoaded', updateAll);

  // Balayage léger : couvre les changements de variante (page produit ET pop-up
  // injecté), sans dépendre d'un événement spécifique au thème.
  setInterval(updateAll, 250);
})();
